export enum InputDirection {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL"
}
